import HCheckArray from "@rf-helper/check-have-value";
import {
  baseState,
  docId,
  formValidationDetail,
  IValidationDocumentsObject
} from "../const/form-validation-details.const";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

function updateDocIdDetails(
  validationDocuments: t[] = [],
  validationDocumentsAlerts: b[] = []
) {
  const formValidationDetailCopy = JSON.parse(JSON.stringify(formValidationDetail));

  if (HCheckArray(validationDocumentsAlerts)) {
    validationDocumentsAlerts.forEach((doc: b) => {
      const docIdEntry = formValidationDetailCopy[doc.document_type_id];
      if (docIdEntry) {
        Object.assign(docIdEntry, {
          status: "warning",
          msg: "Documento pendiente de suministrar",
          disabled: false,
          alert: true,
          name: doc.document_type_name
        });
      }
    });
  }

  if (HCheckArray(validationDocuments)) {
    validationDocuments.forEach((doc: t) => {
      const docIdEntry = formValidationDetailCopy[doc.document_type_id];
      if (docIdEntry) {
        Object.assign(docIdEntry, {
          status: doc.status,
          msg: getMessages(doc),
          disabled: doc.status === "approved",
          alert: false,
          name: doc.document_type_name
        });
      }
    });
  }
  // @ts-ignore
  const state: IValidationDocumentsObject = {};

  Object.keys(docId).forEach(key => {
    // @ts-ignore
    state[key] = formValidationDetailCopy[docId[key]];
  });

  return state;
}

const getValidationDocuments = (response: IPropertyDetailsResponse) => {
  if (
    Object(response).hasOwnProperty("project") &&
    Object(response.project).hasOwnProperty("validation_documents") &&
    Object(response).hasOwnProperty("validation_document_alerts")
  ) {
    const e = updateDocIdDetails(
      response.project.validation_documents as t[],
      response.validation_document_alerts as b[]
    );

    return e as IValidationDocumentsObject;
  } else {
    return baseState;
  }
};
export default getValidationDocuments;

const getMessages = (doc: any) => {
  if (doc.status === "rejected") {
    return doc.status_comment || "";
  }
  if (doc.status === "approved") {
    return "";
  }
  if (doc.status === "warning") {
    return "Documento pendiente de suministrar";
  }
  return "";
};
interface t {
  document_type_id: number;
  document_type_name: string;
  expedition_date: string | null;
  filename: string;
  id: number;
  project_id: number;
  slug: string;
  status: string;
  status_comment: string | null;
  validated_at: string | null;
}

interface b {
  alert_at: string;
  created_at: string;
  document_type_id: number;
  document_type_name: string;
  drop_at: string;
  id: number;
  is_alert_sent: number;
  is_realestate_dropped: number;
  realestate_id: number;
  updated_at: string;
  validation_document_id: number | null;
}
